/*
 * =====================================================================================
 * DISCLAIMER:
 * =====================================================================================
 * This localization file is a community contribution and is not officially maintained
 * by Clerk. It has been provided by the community and may not be fully aligned
 * with the current or future states of the main application. Clerk does not guarantee
 * the accuracy, completeness, or timeliness of the translations in this file.
 * Use of this file is at your own risk and discretion.
 * =====================================================================================
 */

import type { LocalizationResource } from '@clerk/types';

export const bnIN: LocalizationResource = {
  locale: 'bn-IN',
  apiKeys: {
    action__add: undefined,
    action__search: undefined,
    copySecret: {
      formButtonPrimary__copyAndClose: 'কপি করুন এবং বন্ধ করুন',
      formHint: 'নিরাপত্তার কারণে, আমরা আপনাকে পরে এটি আবার দেখতে অনুমতি দেব না।',
      formTitle: 'এখনই আপনার "{{name}}" API কী কপি করুন',
    },
    createdAndExpirationStatus__expiresOn: undefined,
    createdAndExpirationStatus__never: undefined,
    detailsTitle__emptyRow: undefined,
    formButtonPrimary__add: undefined,
    formFieldCaption__expiration__expiresOn: undefined,
    formFieldCaption__expiration__never: undefined,
    formFieldOption__expiration__180d: undefined,
    formFieldOption__expiration__1d: undefined,
    formFieldOption__expiration__1y: undefined,
    formFieldOption__expiration__30d: undefined,
    formFieldOption__expiration__60d: undefined,
    formFieldOption__expiration__7d: undefined,
    formFieldOption__expiration__90d: undefined,
    formFieldOption__expiration__never: undefined,
    formHint: undefined,
    formTitle: undefined,
    lastUsed__days: undefined,
    lastUsed__hours: undefined,
    lastUsed__minutes: undefined,
    lastUsed__months: undefined,
    lastUsed__seconds: undefined,
    lastUsed__years: undefined,
    menuAction__revoke: undefined,
    revokeConfirmation: {
      confirmationText: undefined,
      formButtonPrimary__revoke: undefined,
      formHint: undefined,
      formTitle: undefined,
    },
  },
  backButton: 'পিছনে',
  badge__activePlan: undefined,
  badge__canceledEndsAt: undefined,
  badge__currentPlan: 'বর্তমান প্ল্যান',
  badge__default: 'ডিফল্ট',
  badge__endsAt: undefined,
  badge__expired: 'মেয়াদ শেষ',
  badge__freeTrial: undefined,
  badge__otherImpersonatorDevice: 'অন্য ইমপারসোনেটর ডিভাইস',
  badge__pastDueAt: undefined,
  badge__pastDuePlan: undefined,
  badge__primary: 'প্রাথমিক',
  badge__renewsAt: undefined,
  badge__requiresAction: 'কর্ম প্রয়োজন',
  badge__startsAt: undefined,
  badge__thisDevice: 'এই ডিভাইস',
  badge__trialEndsAt: undefined,
  badge__unverified: 'অযাচাই',
  badge__upcomingPlan: undefined,
  badge__userDevice: 'ব্যবহারকারীর ডিভাইস',
  badge__you: 'আপনি',
  billing: {
    addPaymentMethod__label: undefined,
    alwaysFree: undefined,
    annually: undefined,
    availableFeatures: undefined,
    billedAnnually: 'বার্ষিক হিসাবে বিল করা হয়',
    billedMonthlyOnly: undefined,
    cancelFreeTrial: 'বিনামূল্যের ট্রায়াল বাতিল করুন',
    cancelFreeTrialAccessUntil: 'আপনি {{ date | numeric("bn-IN") }} পর্যন্ত অ্যাক্সেস পাবেন',
    cancelFreeTrialTitle: 'বিনামূল্যের ট্রায়াল বাতিল করুন',
    cancelSubscription: undefined,
    cancelSubscriptionAccessUntil: undefined,
    cancelSubscriptionNoCharge: undefined,
    cancelSubscriptionPastDue: undefined,
    cancelSubscriptionTitle: undefined,
    cannotSubscribeMonthly: undefined,
    cannotSubscribeUnrecoverable: undefined,
    checkout: {
      description__paymentSuccessful: undefined,
      description__subscriptionSuccessful: undefined,
      downgradeNotice: undefined,
      emailForm: {
        subtitle: undefined,
        title: undefined,
      },
      lineItems: {
        title__freeTrialEndsAt: undefined,
        title__paymentMethod: undefined,
        title__statementId: undefined,
        title__subscriptionBegins: undefined,
        title__totalPaid: undefined,
      },
      pastDueNotice: undefined,
      perMonth: undefined,
      title: undefined,
      title__paymentSuccessful: undefined,
      title__subscriptionSuccessful: undefined,
      title__trialSuccess: undefined,
      totalDueAfterTrial: undefined,
    },
    credit: undefined,
    creditRemainder: undefined,
    defaultFreePlanActive: undefined,
    free: 'বিনামূল্যে',
    getStarted: 'শুরু করুন',
    keepFreeTrial: undefined,
    keepSubscription: undefined,
    manage: undefined,
    manageSubscription: 'সদস্যতা পরিচালনা করুন',
    month: 'মাস',
    monthly: undefined,
    pastDue: undefined,
    pay: undefined,
    paymentMethod: {
      applePayDescription: {
        annual: undefined,
        monthly: undefined,
      },
      dev: {
        anyNumbers: undefined,
        cardNumber: undefined,
        cvcZip: undefined,
        developmentMode: undefined,
        expirationDate: undefined,
        testCardInfo: undefined,
      },
    },
    paymentMethods__label: undefined,
    popular: undefined,
    pricingTable: {
      billingCycle: undefined,
      included: undefined,
    },
    reSubscribe: undefined,
    seeAllFeatures: undefined,
    startFreeTrial: undefined,
    startFreeTrial__days: undefined,
    subscribe: undefined,
    subscriptionDetails: {
      beginsOn: undefined,
      currentBillingCycle: undefined,
      endsOn: undefined,
      firstPaymentAmount: undefined,
      firstPaymentOn: undefined,
      nextPaymentAmount: undefined,
      nextPaymentOn: undefined,
      pastDueAt: undefined,
      renewsAt: undefined,
      subscribedOn: undefined,
      title: undefined,
      trialEndsOn: undefined,
      trialStartedOn: undefined,
    },
    subtotal: undefined,
    switchPlan: 'এই প্ল্যানে পরিবর্তন করুন',
    switchToAnnual: undefined,
    switchToAnnualWithAnnualPrice: undefined,
    switchToMonthly: undefined,
    switchToMonthlyWithPrice: undefined,
    totalDue: undefined,
    totalDueToday: undefined,
    viewFeatures: undefined,
    viewPayment: undefined,
    year: undefined,
  },
  createOrganization: {
    formButtonSubmit: 'সংগঠন তৈরি করুন',
    invitePage: {
      formButtonReset: 'এড়িয়ে যান',
    },
    title: 'সংগঠন তৈরি করুন',
  },
  dates: {
    lastDay: "গতকাল {{ date | timeString('bn-IN') }}",
    next6Days: "{{ date | weekday('bn-IN','long') }} {{ date | timeString('bn-IN') }}",
    nextDay: "আগামীকাল {{ date | timeString('bn-IN') }}",
    numeric: "{{ date | numeric('bn-IN') }}",
    previous6Days: "গত {{ date | weekday('bn-IN','long') }} {{ date | timeString('bn-IN') }}",
    sameDay: "আজ {{ date | timeString('bn-IN') }}",
  },
  dividerText: 'অথবা',
  footerActionLink__alternativePhoneCodeProvider: undefined,
  footerActionLink__useAnotherMethod: 'অন্য পদ্ধতি ব্যবহার করুন',
  footerPageLink__help: 'সাহায্য',
  footerPageLink__privacy: 'গোপনীয়তা',
  footerPageLink__terms: 'শর্তাবলী',
  formButtonPrimary: 'চালিয়ে যান',
  formButtonPrimary__verify: 'যাচাই করুন',
  formFieldAction__forgotPassword: 'পাসওয়ার্ড ভুলে গেছেন?',
  formFieldError__matchingPasswords: 'পাসওয়ার্ড মিলেছে।',
  formFieldError__notMatchingPasswords: 'পাসওয়ার্ড মিলে না।',
  formFieldError__verificationLinkExpired: 'যাচাইকরণ লিংকের মেয়াদ শেষ হয়েছে। দয়া করে একটি নতুন লিংক অনুরোধ করুন।',
  formFieldHintText__optional: 'ঐচ্ছিক',
  formFieldHintText__slug: 'স্লাগ একটি মানব-পাঠযোগ্য আইডি যা অবশ্যই অনন্য হতে হবে। এটি প্রায়শই URL-এ ব্যবহৃত হয়।',
  formFieldInputPlaceholder__apiKeyDescription: undefined,
  formFieldInputPlaceholder__apiKeyExpirationDate: undefined,
  formFieldInputPlaceholder__apiKeyName: undefined,
  formFieldInputPlaceholder__backupCode: 'ব্যাকআপ কোড লিখুন',
  formFieldInputPlaceholder__confirmDeletionUserAccount: 'অ্যাকাউন্ট মুছুন',
  formFieldInputPlaceholder__emailAddress: 'আপনার ইমেইল ঠিকানা লিখুন',
  formFieldInputPlaceholder__emailAddress_username: 'ইমেইল বা ব্যবহারকারীর নাম লিখুন',
  formFieldInputPlaceholder__emailAddresses: 'example@email.com, example2@email.com',
  formFieldInputPlaceholder__firstName: 'নামের প্রথম অংশ',
  formFieldInputPlaceholder__lastName: 'নামের শেষ অংশ',
  formFieldInputPlaceholder__organizationDomain: 'example.com',
  formFieldInputPlaceholder__organizationDomainEmailAddress: 'you@example.com',
  formFieldInputPlaceholder__organizationName: 'সংগঠনের নাম',
  formFieldInputPlaceholder__organizationSlug: 'my-org',
  formFieldInputPlaceholder__password: 'আপনার পাসওয়ার্ড লিখুন',
  formFieldInputPlaceholder__phoneNumber: 'আপনার ফোন নম্বর লিখুন',
  formFieldInputPlaceholder__username: undefined,
  formFieldInput__emailAddress_format: undefined,
  formFieldLabel__apiKey: 'API কী',
  formFieldLabel__apiKeyDescription: 'বিবরণ',
  formFieldLabel__apiKeyExpiration: 'মেয়াদ শেষ',
  formFieldLabel__apiKeyName: 'গোপন কী-এর নাম',
  formFieldLabel__automaticInvitations: 'এই ডোমেনের জন্য স্বয়ংক্রিয় আমন্ত্রণ সক্ষম করুন',
  formFieldLabel__backupCode: 'ব্যাকআপ কোড',
  formFieldLabel__confirmDeletion: 'নিশ্চিতকরণ',
  formFieldLabel__confirmPassword: 'পাসওয়ার্ড নিশ্চিত করুন',
  formFieldLabel__currentPassword: 'বর্তমান পাসওয়ার্ড',
  formFieldLabel__emailAddress: 'ইমেইল ঠিকানা',
  formFieldLabel__emailAddress_username: 'ইমেইল ঠিকানা বা ব্যবহারকারীর নাম',
  formFieldLabel__emailAddresses: 'ইমেইল ঠিকানাসমূহ',
  formFieldLabel__firstName: 'নামের প্রথম অংশ',
  formFieldLabel__lastName: 'নামের শেষ অংশ',
  formFieldLabel__newPassword: 'নতুন পাসওয়ার্ড',
  formFieldLabel__organizationDomain: 'ডোমেইন',
  formFieldLabel__organizationDomainDeletePending: 'মুছে ফেলা অপেক্ষিত আমন্ত্রণ এবং সাজেশন',
  formFieldLabel__organizationDomainEmailAddress: 'যাচাইকরণ ইমেইল ঠিকানা',
  formFieldLabel__organizationDomainEmailAddressDescription:
    'এই ডোমেনের অধীনে একটি ইমেইল ঠিকানা লিখুন, একটি কোড পেতে এবং এই ডোমেন যাচাই করতে।',
  formFieldLabel__organizationName: 'নাম',
  formFieldLabel__organizationSlug: 'স্লাগ',
  formFieldLabel__passkeyName: 'পাসকি-এর নাম',
  formFieldLabel__password: 'পাসওয়ার্ড',
  formFieldLabel__phoneNumber: 'ফোন নম্বর',
  formFieldLabel__role: 'ভূমিকা',
  formFieldLabel__signOutOfOtherSessions: 'অন্য সব ডিভাইস থেকে সাইন আউট করুন',
  formFieldLabel__username: 'ব্যবহারকারীর নাম',
  impersonationFab: {
    action__signOut: 'সাইন আউট',
    title: '{{identifier}} হিসাবে সাইন ইন করা হয়েছে',
  },
  lastAuthenticationStrategy: 'শেষবার ব্যবহৃত',
  maintenanceMode:
    'আমরা বর্তমানে রক্ষণাবেক্ষণের কাজ করছি, কিন্তু চিন্তা করবেন না, এটি কয়েক মিনিটের বেশি সময় নেবে না।',
  membershipRole__admin: 'অ্যাডমিন',
  membershipRole__basicMember: 'সদস্য',
  membershipRole__guestMember: 'অতিথি',
  organizationList: {
    action__createOrganization: 'সংগঠন তৈরি করুন',
    action__invitationAccept: 'যোগ দিন',
    action__suggestionsAccept: 'যোগ দেওয়ার অনুরোধ করুন',
    createOrganization: 'সংগঠন তৈরি করুন',
    invitationAcceptedLabel: 'যোগ দেওয়া হয়েছে',
    subtitle: '{{applicationName}}-এ চালিয়ে যাওয়ার জন্য',
    suggestionsAcceptedLabel: 'অনুমোদনের অপেক্ষায়',
    title: 'একটি অ্যাকাউন্ট চয়ন করুন',
    titleWithoutPersonal: 'একটি সংগঠন চয়ন করুন',
  },
  organizationProfile: {
    apiKeysPage: {
      title: undefined,
    },
    badge__automaticInvitation: 'স্বয়ংক্রিয় আমন্ত্রণ',
    badge__automaticSuggestion: 'স্বয়ংক্রিয় সাজেশন',
    badge__manualInvitation: 'কোনো স্বয়ংক্রিয় তালিকাভুক্তি নেই',
    badge__unverified: 'অযাচাই',
    billingPage: {
      paymentHistorySection: {
        empty: undefined,
        notFound: undefined,
        tableHeader__amount: undefined,
        tableHeader__date: undefined,
        tableHeader__status: undefined,
      },
      paymentMethodsSection: {
        actionLabel__default: 'ডিফল্ট করুন',
        actionLabel__remove: 'সরান',
        add: 'নতুন পেমেন্ট উৎস যোগ করুন',
        addSubtitle: 'আপনার অ্যাকাউন্টে একটি নতুন পেমেন্ট উৎস যোগ করুন।',
        cancelButton: 'বাতিল করুন',
        formButtonPrimary__add: 'পেমেন্ট পদ্ধতি যোগ করুন',
        formButtonPrimary__pay: '{{amount}} প্রদান করুন',
        payWithTestCardButton: undefined,
        removeMethod: {
          messageLine1: '{{identifier}} এই অ্যাকাউন্ট থেকে সরানো হবে।',
          messageLine2:
            'আপনি আর এই পেমেন্ট উৎস ব্যবহার করতে পারবেন না এবং এর উপর নির্ভরশীল যেকোনো আবর্তক সাবস্ক্রিপশন আর কাজ করবে না।',
          successMessage: '{{paymentMethod}} আপনার অ্যাকাউন্ট থেকে সরানো হয়েছে।',
          title: 'পেমেন্ট উৎস সরান',
        },
        title: 'উপলব্ধ বিকল্প',
      },
      start: {
        headerTitle__payments: undefined,
        headerTitle__plans: 'প্ল্যান',
        headerTitle__statements: 'ইনভয়েস',
        headerTitle__subscriptions: undefined,
      },
      statementsSection: {
        empty: undefined,
        itemCaption__paidForPlan: undefined,
        itemCaption__proratedCredit: undefined,
        itemCaption__subscribedAndPaidForPlan: undefined,
        notFound: undefined,
        tableHeader__amount: undefined,
        tableHeader__date: undefined,
        title: undefined,
        totalPaid: undefined,
      },
      subscriptionsListSection: {
        actionLabel__manageSubscription: undefined,
        actionLabel__newSubscription: undefined,
        actionLabel__switchPlan: undefined,
        tableHeader__edit: undefined,
        tableHeader__plan: undefined,
        tableHeader__startDate: undefined,
        title: undefined,
      },
      subscriptionsSection: {
        actionLabel__default: undefined,
      },
      switchPlansSection: {
        title: undefined,
      },
      title: 'বিলিং ও পেমেন্ট',
    },
    createDomainPage: {
      subtitle:
        'যাচাই করার জন্য ডোমেন যোগ করুন। এই ডোমেনে ইমেইল ঠিকানা সহ ব্যবহারকারীরা স্বয়ংক্রিয়ভাবে সংগঠনে যোগ দিতে পারেন বা যোগ দেওয়ার অনুরোধ করতে পারেন।',
      title: 'ডোমেন যোগ করুন',
    },
    invitePage: {
      detailsTitle__inviteFailed:
        'আমন্ত্রণ পাঠানো যায়নি। নিম্নলিখিত ইমেইল ঠিকানাগুলির জন্য ইতিমধ্যে অপেক্ষিত আমন্ত্রণ রয়েছে: {{email_addresses}}।',
      formButtonPrimary__continue: 'আমন্ত্রণ পাঠান',
      selectDropdown__role: 'ভূমিকা নির্বাচন করুন',
      subtitle: 'একটি বা একাধিক ইমেইল ঠিকানা লিখুন বা পেস্ট করুন, স্পেস বা কমা দ্বারা পৃথক করে।',
      successMessage: 'আমন্ত্রণ সফলভাবে পাঠানো হয়েছে',
      title: 'নতুন সদস্যদের আমন্ত্রণ করুন',
    },
    membersPage: {
      action__invite: 'আমন্ত্রণ',
      action__search: 'অনুসন্ধান',
      activeMembersTab: {
        menuAction__remove: 'সদস্য সরান',
        tableHeader__actions: 'কার্যক্রম',
        tableHeader__joined: 'যোগ দেওয়া',
        tableHeader__role: 'ভূমিকা',
        tableHeader__user: 'ব্যবহারকারী',
      },
      detailsTitle__emptyRow: 'প্রদর্শন করার জন্য কোনো সদস্য নেই',
      invitationsTab: {
        autoInvitations: {
          headerSubtitle:
            'আপনার সংগঠনের সাথে একটি ইমেইল ডোমেন সংযুক্ত করে ব্যবহারকারীদের আমন্ত্রণ করুন। যে কেউ মিলে যাওয়া ইমেইল ডোমেন দিয়ে সাইন আপ করবে, তারা যে কোনো সময় সংগঠনে যোগ দিতে পারবে।',
          headerTitle: 'স্বয়ংক্রিয় আমন্ত্রণ',
          primaryButton: 'যাচাইকৃত ডোমেন পরিচালনা করুন',
        },
        table__emptyRow: 'প্রদর্শন করার জন্য কোনো আমন্ত্রণ নেই',
      },
      invitedMembersTab: {
        menuAction__revoke: 'আমন্ত্রণ প্রত্যাহার করুন',
        tableHeader__invited: 'আমন্ত্রিত',
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle:
            'যে ব্যবহারকারীরা মিলে যাওয়া ইমেইল ডোমেন দিয়ে সাইন আপ করেন, তারা আপনার সংগঠনে যোগ দেওয়ার অনুরোধ করার জন্য একটি সাজেশন দেখতে পাবেন।',
          headerTitle: 'স্বয়ংক্রিয় সাজেশন',
          primaryButton: 'যাচাইকৃত ডোমেন পরিচালনা করুন',
        },
        menuAction__approve: 'অনুমোদন',
        menuAction__reject: 'প্রত্যাখ্যান',
        tableHeader__requested: 'অ্যাক্সেস অনুরোধ করেছে',
        table__emptyRow: 'প্রদর্শন করার জন্য কোনো অনুরোধ নেই',
      },
      start: {
        headerTitle__invitations: 'আমন্ত্রণ',
        headerTitle__members: 'সদস্য',
        headerTitle__requests: 'অনুরোধ',
      },
      alerts: {
        roleSetMigrationInProgress: {
          title: 'ভূমিকাগুলি সাময়িকভাবে লক করা আছে',
          subtitle: 'আমরা উপলব্ধ ভূমিকাগুলি আপডেট করছি। এটি সম্পন্ন হলে, আপনি আবার ভূমিকা আপডেট করতে পারবেন।',
        },
      },
    },
    navbar: {
      apiKeys: undefined,
      billing: 'বিলিং',
      description: 'আপনার সংগঠন পরিচালনা করুন।',
      general: 'সাধারণ',
      members: 'সদস্য',
      title: 'সংগঠন',
    },
    plansPage: {
      alerts: {
        noPermissionsToManageBilling: undefined,
      },
      title: undefined,
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: 'চালিয়ে যেতে নীচে "{{organizationName}}" টাইপ করুন।',
          messageLine1: 'আপনি কি নিশ্চিত যে আপনি এই সংগঠন মুছতে চান?',
          messageLine2: 'এই কার্যটি স্থায়ী এবং অপরিবর্তনীয়।',
          successMessage: 'আপনি সংগঠনটি মুছে ফেলেছেন।',
          title: 'সংগঠন মুছুন',
        },
        leaveOrganization: {
          actionDescription: 'চালিয়ে যেতে নীচে "{{organizationName}}" টাইপ করুন।',
          messageLine1:
            'আপনি কি নিশ্চিত যে আপনি এই সংগঠন ছেড়ে যেতে চান? আপনি এই সংগঠন এবং এর অ্যাপ্লিকেশনগুলির অ্যাক্সেস হারাবেন।',
          messageLine2: 'এই কার্যটি স্থায়ী এবং অপরিবর্তনীয়।',
          successMessage: 'আপনি সংগঠন ছেড়ে চলে গেছেন।',
          title: 'সংগঠন ছেড়ে যান',
        },
        title: 'বিপদ',
      },
      domainSection: {
        menuAction__manage: 'পরিচালনা',
        menuAction__remove: 'মুছুন',
        menuAction__verify: 'যাচাই',
        primaryButton: 'ডোমেন যোগ করুন',
        subtitle:
          'একটি যাচাইকৃত ইমেইল ডোমেনের ভিত্তিতে ব্যবহারকারীদের স্বয়ংক্রিয়ভাবে সংগঠনে যোগ দিতে বা যোগ দেওয়ার অনুরোধ করতে দিন।',
        title: 'যাচাইকৃত ডোমেন',
      },
      successMessage: 'সংগঠন আপডেট করা হয়েছে।',
      title: 'প্রোফাইল আপডেট করুন',
    },
    removeDomainPage: {
      messageLine1: 'ইমেইল ডোমেন {{domain}} সরানো হবে।',
      messageLine2: 'এর পরে ব্যবহারকারীরা স্বয়ংক্রিয়ভাবে সংগঠনে যোগ দিতে পারবেন না।',
      successMessage: '{{domain}} সরানো হয়েছে।',
      title: 'ডোমেন সরান',
    },
    start: {
      headerTitle__general: 'সাধারণ',
      headerTitle__members: 'সদস্য',
      profileSection: {
        primaryButton: 'প্রোফাইল আপডেট করুন',
        title: 'সংগঠনের প্রোফাইল',
        uploadAction__title: 'লোগো',
      },
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: 'এই ডোমেন সরানো আমন্ত্রিত ব্যবহারকারীদের প্রভাবিত করবে।',
        removeDomainActionLabel__remove: 'ডোমেন সরান',
        removeDomainSubtitle: 'আপনার যাচাইকৃত ডোমেন থেকে এই ডোমেন সরান',
        removeDomainTitle: 'ডোমেন সরান',
      },
      enrollmentTab: {
        automaticInvitationOption__description:
          'ব্যবহারকারীদের স্বয়ংক্রিয়ভাবে সংগঠনে যোগ দেওয়ার আমন্ত্রণ জানানো হয় যখন তারা সাইন-আপ করেন এবং যে কোনো সময় যোগ দিতে পারেন।',
        automaticInvitationOption__label: 'স্বয়ংক্রিয় আমন্ত্রণ',
        automaticSuggestionOption__description:
          'ব্যবহারকারীরা যোগ দেওয়ার অনুরোধের একটি সাজেশন পান, কিন্তু সংগঠনে যোগ দেওয়ার আগে একজন অ্যাডমিন দ্বারা অনুমোদিত হতে হবে।',
        automaticSuggestionOption__label: 'স্বয়ংক্রিয় সাজেশন',
        calloutInfoLabel: 'তালিকাভুক্তি মোড পরিবর্তন করলে শুধুমাত্র নতুন ব্যবহারকারীদের প্রভাবিত করবে।',
        calloutInvitationCountLabel: 'ব্যবহারকারীদের কাছে পাঠানো অপেক্ষিত আমন্ত্রণ: {{count}}',
        calloutSuggestionCountLabel: 'ব্যবহারকারীদের কাছে পাঠানো অপেক্ষিত সাজেশন: {{count}}',
        manualInvitationOption__description: 'ব্যবহারকারীদের শুধুমাত্র ম্যানুয়ালি সংগঠনে আমন্ত্রণ করা যেতে পারে।',
        manualInvitationOption__label: 'কোনো স্বয়ংক্রিয় তালিকাভুক্তি নেই',
        subtitle: 'এই ডোমেন থেকে ব্যবহারকারীরা কিভাবে সংগঠনে যোগ দিতে পারেন তা নির্বাচন করুন।',
      },
      start: {
        headerTitle__danger: 'বিপদ',
        headerTitle__enrollment: 'তালিকাভুক্তি বিকল্প',
      },
      subtitle: 'ডোমেন {{domain}} এখন যাচাই করা হয়েছে। তালিকাভুক্তি মোড নির্বাচন করে চালিয়ে যান।',
      title: '{{domain}} আপডেট করুন',
    },
    verifyDomainPage: {
      formSubtitle: 'আপনার ইমেইল ঠিকানায় পাঠানো যাচাইকরণ কোড লিখুন',
      formTitle: 'যাচাইকরণ কোড',
      resendButton: 'কোনো কোড পাননি? পুনরায় পাঠান',
      subtitle: 'ডোমেন {{domainName}} ইমেইলের মাধ্যমে যাচাই করা প্রয়োজন।',
      subtitleVerificationCodeScreen: '{{emailAddress}}-এ একটি যাচাইকরণ কোড পাঠানো হয়েছে। চালিয়ে যেতে কোডটি লিখুন।',
      title: 'ডোমেন যাচাই করুন',
    },
  },
  organizationSwitcher: {
    action__closeOrganizationSwitcher: undefined,
    action__createOrganization: 'সংগঠন তৈরি করুন',
    action__invitationAccept: 'যোগ দিন',
    action__manageOrganization: 'পরিচালনা',
    action__openOrganizationSwitcher: undefined,
    action__suggestionsAccept: 'যোগ দেওয়ার অনুরোধ করুন',
    notSelected: 'কোনো সংগঠন নির্বাচিত নেই',
    personalWorkspace: 'ব্যক্তিগত অ্যাকাউন্ট',
    suggestionsAcceptedLabel: 'অনুমোদনের অপেক্ষায়',
  },
  paginationButton__next: 'পরবর্তী',
  paginationButton__previous: 'পূর্ববর্তী',
  paginationRowText__displaying: 'প্রদর্শন করা হচ্ছে',
  paginationRowText__of: 'এর মধ্যে',
  reverification: {
    alternativeMethods: {
      actionLink: 'সাহায্য পান',
      actionText: 'এর কোনটিই নেই?',
      blockButton__backupCode: 'একটি ব্যাকআপ কোড ব্যবহার করুন',
      blockButton__emailCode: '{{identifier}}-এ ইমেইল কোড পাঠান',
      blockButton__passkey: 'আপনার পাসকি ব্যবহার করুন',
      blockButton__password: 'আপনার পাসওয়ার্ড দিয়ে চালিয়ে যান',
      blockButton__phoneCode: '{{identifier}}-এ এসএমএস কোড পাঠান',
      blockButton__totp: 'আপনার অথেনটিকেটর অ্যাপ ব্যবহার করুন',
      getHelp: {
        blockButton__emailSupport: 'ইমেইল সাপোর্ট',
        content:
          'আপনার অ্যাকাউন্ট যাচাই করতে সমস্যা হলে, আমাদের ইমেইল করুন এবং আমরা যত তাড়াতাড়ি সম্ভব অ্যাক্সেস পুনরুদ্ধার করতে আপনার সাথে কাজ করব।',
        title: 'সাহায্য পান',
      },
      subtitle: 'সমস্যা হচ্ছে? যাচাইকরণের জন্য আপনি এই পদ্ধতিগুলির যেকোনো একটি ব্যবহার করতে পারেন।',
      title: 'অন্য পদ্ধতি ব্যবহার করুন',
    },
    backupCodeMfa: {
      subtitle: 'দুই-ধাপ যাচাইকরণ সেট আপ করার সময় আপনি যে ব্যাকআপ কোড পেয়েছিলেন তা লিখুন',
      title: 'একটি ব্যাকআপ কোড লিখুন',
    },
    emailCode: {
      formTitle: 'যাচাইকরণ কোড',
      resendButton: 'কোনো কোড পাননি? পুনরায় পাঠান',
      subtitle: 'চালিয়ে যেতে আপনার ইমেইলে পাঠানো কোড লিখুন',
      title: 'যাচাইকরণ প্রয়োজন',
    },
    noAvailableMethods: {
      message: 'যাচাইকরণ চালিয়ে যাওয়া যাচ্ছে না। কোনো উপযুক্ত অথেনটিকেশন ফ্যাক্টর কনফিগার করা নেই',
      subtitle: 'একটি ত্রুটি ঘটেছে',
      title: 'আপনার অ্যাকাউন্ট যাচাই করা যাচ্ছে না',
    },
    passkey: {
      blockButton__passkey: 'আপনার পাসকি ব্যবহার করুন',
      subtitle:
        'আপনার পাসকি ব্যবহার করে আপনার পরিচয় নিশ্চিত করা হয়। আপনার ডিভাইস আপনার আঙ্গুলের ছাপ, মুখ বা স্ক্রিন লক চাইতে পারে।',
      title: 'আপনার পাসকি ব্যবহার করুন',
    },
    password: {
      actionLink: 'অন্য পদ্ধতি ব্যবহার করুন',
      subtitle: 'চালিয়ে যেতে আপনার বর্তমান পাসওয়ার্ড লিখুন',
      title: 'যাচাইকরণ প্রয়োজন',
    },
    phoneCode: {
      formTitle: 'যাচাইকরণ কোড',
      resendButton: 'কোনো কোড পাননি? পুনরায় পাঠান',
      subtitle: 'চালিয়ে যেতে আপনার ফোনে পাঠানো কোড লিখুন',
      title: 'যাচাইকরণ প্রয়োজন',
    },
    phoneCodeMfa: {
      formTitle: 'যাচাইকরণ কোড',
      resendButton: 'কোনো কোড পাননি? পুনরায় পাঠান',
      subtitle: 'চালিয়ে যেতে আপনার ফোনে পাঠানো কোড লিখুন',
      title: 'যাচাইকরণ প্রয়োজন',
    },
    totpMfa: {
      formTitle: 'যাচাইকরণ কোড',
      subtitle: 'চালিয়ে যেতে আপনার অথেনটিকেটর অ্যাপ দ্বারা উৎপন্ন কোড লিখুন',
      title: 'যাচাইকরণ প্রয়োজন',
    },
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: 'অ্যাকাউন্ট যোগ করুন',
      action__signOutAll: 'সব অ্যাকাউন্ট থেকে সাইন আউট করুন',
      subtitle: 'যে অ্যাকাউন্ট দিয়ে চালিয়ে যেতে চান তা নির্বাচন করুন।',
      title: 'একটি অ্যাকাউন্ট চয়ন করুন',
    },
    alternativeMethods: {
      actionLink: 'সাহায্য পান',
      actionText: 'এর কোনটিই নেই?',
      blockButton__backupCode: 'একটি ব্যাকআপ কোড ব্যবহার করুন',
      blockButton__emailCode: '{{identifier}}-এ ইমেইল কোড পাঠান',
      blockButton__emailLink: '{{identifier}}-এ ইমেইল লিংক পাঠান',
      blockButton__passkey: 'আপনার পাসকি দিয়ে সাইন ইন করুন',
      blockButton__password: 'আপনার পাসওয়ার্ড দিয়ে সাইন ইন করুন',
      blockButton__phoneCode: '{{identifier}}-এ এসএমএস কোড পাঠান',
      blockButton__totp: 'আপনার অথেনটিকেটর অ্যাপ ব্যবহার করুন',
      getHelp: {
        blockButton__emailSupport: 'ইমেইল সাপোর্ট',
        content:
          'আপনার অ্যাকাউন্টে সাইন ইন করতে সমস্যা হলে, আমাদের ইমেইল করুন এবং আমরা যত তাড়াতাড়ি সম্ভব অ্যাক্সেস পুনরুদ্ধার করতে আপনার সাথে কাজ করব।',
        title: 'সাহায্য পান',
      },
      subtitle: 'সমস্যা হচ্ছে? সাইন ইন করতে আপনি এই পদ্ধতিগুলির যেকোনো একটি ব্যবহার করতে পারেন।',
      title: 'অন্য পদ্ধতি ব্যবহার করুন',
    },
    alternativePhoneCodeProvider: {
      formTitle: undefined,
      resendButton: undefined,
      subtitle: undefined,
      title: undefined,
    },
    backupCodeMfa: {
      subtitle: 'আপনার ব্যাকআপ কোড হল যেটি আপনি দুই-ধাপ যাচাইকরণ সেট আপ করার সময় পেয়েছিলেন।',
      title: 'একটি ব্যাকআপ কোড লিখুন',
    },
    emailCode: {
      formTitle: 'যাচাইকরণ কোড',
      resendButton: 'কোনো কোড পাননি? পুনরায় পাঠান',
      subtitle: '{{applicationName}}-এ চালিয়ে যাওয়ার জন্য',
      title: 'আপনার ইমেইল চেক করুন',
    },
    emailCodeMfa: {
      formTitle: 'আপনার ইমেইল চেক করুন',
      resendButton: 'কোনো কোড পাননি? পুনরায় পাঠান',
      subtitle: '{{applicationName}}-এ চালিয়ে যাওয়ার জন্য',
      title: 'আপনার ইমেইল চেক করুন',
    },
    emailLink: {
      clientMismatch: {
        subtitle: 'চালিয়ে যেতে, যে ডিভাইস এবং ব্রাউজার থেকে আপনি সাইন-ইন শুরু করেছেন সেখানে যাচাইকরণ লিংক খুলুন',
        title: 'এই ডিভাইসের জন্য যাচাইকরণ লিংক অবৈধ',
      },
      expired: {
        subtitle: 'চালিয়ে যেতে আসল ট্যাবে ফিরে যান।',
        title: 'এই যাচাইকরণ লিংকের মেয়াদ শেষ হয়ে গেছে',
      },
      failed: {
        subtitle: 'চালিয়ে যেতে আসল ট্যাবে ফিরে যান।',
        title: 'এই যাচাইকরণ লিংক অবৈধ',
      },
      formSubtitle: 'আপনার ইমেইলে পাঠানো যাচাইকরণ লিংক ব্যবহার করুন',
      formTitle: 'যাচাইকরণ লিংক',
      loading: {
        subtitle: 'আপনি শীঘ্রই রিডাইরেক্ট হবেন',
        title: 'সাইন ইন করা হচ্ছে...',
      },
      resendButton: 'কোনো লিংক পাননি? পুনরায় পাঠান',
      subtitle: '{{applicationName}}-এ চালিয়ে যাওয়ার জন্য',
      title: 'আপনার ইমেইল চেক করুন',
      unusedTab: {
        title: 'আপনি এই ট্যাব বন্ধ করতে পারেন',
      },
      verified: {
        subtitle: 'আপনি শীঘ্রই রিডাইরেক্ট হবেন',
        title: 'সফলভাবে সাইন ইন হয়েছে',
      },
      verifiedSwitchTab: {
        subtitle: 'চালিয়ে যেতে আসল ট্যাবে ফিরে যান',
        subtitleNewTab: 'চালিয়ে যেতে নতুন খোলা ট্যাবে ফিরে যান',
        titleNewTab: 'অন্য ট্যাবে সাইন ইন হয়েছে',
      },
    },
    emailLinkMfa: {
      formSubtitle: 'আপনার ইমেইলে পাঠানো যাচাইকরণ লিঙ্কটি ব্যবহার করুন',
      resendButton: 'লিঙ্ক পাননি? আবার পাঠান',
      subtitle: '{{applicationName}} এ চালিয়ে যেতে',
      title: 'আপনার ইমেইল পরীক্ষা করুন',
    },
    enterpriseConnections: {
      subtitle: undefined,
      title: undefined,
    },
    forgotPassword: {
      formTitle: 'পাসওয়ার্ড রিসেট কোড',
      resendButton: 'কোনো কোড পাননি? পুনরায় পাঠান',
      subtitle: 'আপনার পাসওয়ার্ড রিসেট করতে',
      subtitle_email: 'প্রথমে, আপনার ইমেইল ঠিকানায় পাঠানো কোড লিখুন',
      subtitle_phone: 'প্রথমে, আপনার ফোনে পাঠানো কোড লিখুন',
      title: 'পাসওয়ার্ড রিসেট করুন',
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: 'আপনার পাসওয়ার্ড রিসেট করুন',
      label__alternativeMethods: 'অথবা, অন্য পদ্ধতি দিয়ে সাইন ইন করুন',
      title: 'পাসওয়ার্ড ভুলে গেছেন?',
    },
    newDeviceVerificationNotice:
      'আপনি একটি নতুন ডিভাইস থেকে সাইন ইন করছেন। আমরা আপনার অ্যাকাউন্ট নিরাপদ রাখতে যাচাইকরণ চাইছি।',
    noAvailableMethods: {
      message: 'সাইন ইন চালিয়ে যাওয়া যাচ্ছে না। কোনো উপলব্ধ অথেনটিকেশন ফ্যাক্টর নেই।',
      subtitle: 'একটি ত্রুটি ঘটেছে',
      title: 'সাইন ইন করা যাচ্ছে না',
    },
    passkey: {
      subtitle:
        'আপনার পাসকি ব্যবহার করলে নিশ্চিত হয় যে এটি আপনি। আপনার ডিভাইস আপনার আঙ্গুলের ছাপ, মুখ বা স্ক্রিন লক চাইতে পারে।',
      title: 'আপনার পাসকি ব্যবহার করুন',
    },
    password: {
      actionLink: 'অন্য পদ্ধতি ব্যবহার করুন',
      subtitle: 'আপনার অ্যাকাউন্টের সাথে যুক্ত পাসওয়ার্ড লিখুন',
      title: 'আপনার পাসওয়ার্ড লিখুন',
    },
    passwordCompromised: {
      title: undefined,
    },
    passwordPwned: {
      title: 'পাসওয়ার্ড সমঝোতা হয়েছে',
    },
    passwordUntrusted: {
      title: undefined,
    },
    phoneCode: {
      formTitle: 'যাচাইকরণ কোড',
      resendButton: 'কোনো কোড পাননি? পুনরায় পাঠান',
      subtitle: '{{applicationName}}-এ চালিয়ে যাওয়ার জন্য',
      title: 'আপনার ফোন চেক করুন',
    },
    phoneCodeMfa: {
      formTitle: 'যাচাইকরণ কোড',
      resendButton: 'কোনো কোড পাননি? পুনরায় পাঠান',
      subtitle: 'চালিয়ে যেতে, আপনার ফোনে পাঠানো যাচাইকরণ কোড লিখুন',
      title: 'আপনার ফোন চেক করুন',
    },
    resetPassword: {
      formButtonPrimary: 'পাসওয়ার্ড রিসেট করুন',
      requiredMessage: 'নিরাপত্তা কারণে, আপনার পাসওয়ার্ড রিসেট করা প্রয়োজন।',
      successMessage:
        'আপনার পাসওয়ার্ড সফলভাবে পরিবর্তন করা হয়েছে। আপনাকে সাইন ইন করা হচ্ছে, দয়া করে একটু অপেক্ষা করুন।',
      title: 'নতুন পাসওয়ার্ড সেট করুন',
    },
    resetPasswordMfa: {
      detailsLabel: 'আপনার পাসওয়ার্ড রিসেট করার আগে আমাদের আপনার পরিচয় যাচাই করতে হবে।',
    },
    start: {
      actionLink: 'সাইন আপ করুন',
      actionLink__join_waitlist: 'ওয়েটলিস্টে যোগ দিন',
      actionLink__use_email: 'ইমেইল ব্যবহার করুন',
      actionLink__use_email_username: 'ইমেইল বা ব্যবহারকারীর নাম ব্যবহার করুন',
      actionLink__use_passkey: 'পরিবর্তে পাসকি ব্যবহার করুন',
      actionLink__use_phone: 'ফোন ব্যবহার করুন',
      actionLink__use_username: 'ব্যবহারকারীর নাম ব্যবহার করুন',
      actionText: 'কোনো অ্যাকাউন্ট নেই?',
      actionText__join_waitlist: 'আগাম অ্যাক্সেস চান?',
      alternativePhoneCodeProvider: {
        actionLink: undefined,
        label: undefined,
        subtitle: undefined,
        title: undefined,
      },
      subtitle: 'স্বাগতম! চালিয়ে যেতে দয়া করে সাইন ইন করুন',
      subtitleCombined: undefined,
      title: '{{applicationName}}-এ সাইন ইন করুন',
      titleCombined: '{{applicationName}}-এ চালিয়ে যান',
    },
    totpMfa: {
      formTitle: 'যাচাইকরণ কোড',
      subtitle: 'চালিয়ে যেতে, আপনার অথেনটিকেটর অ্যাপ দ্বারা উৎপন্ন যাচাইকরণ কোড লিখুন',
      title: 'দুই-ধাপ যাচাইকরণ',
    },
    web3Solana: {
      subtitle: 'সাইন ইন করতে নিচে একটি ওয়ালেট নির্বাচন করুন',
      title: 'Solana দিয়ে সাইন ইন করুন',
    },
  },
  signInEnterPasswordTitle: 'আপনার পাসওয়ার্ড লিখুন',
  signUp: {
    alternativePhoneCodeProvider: {
      resendButton: undefined,
      subtitle: undefined,
      title: undefined,
    },
    continue: {
      actionLink: 'সাইন ইন করুন',
      actionText: 'ইতিমধ্যে একটি অ্যাকাউন্ট আছে?',
      subtitle: 'চালিয়ে যেতে দয়া করে বাকি তথ্য পূরণ করুন।',
      title: 'অনুপস্থিত ক্ষেত্রগুলি পূরণ করুন',
    },
    emailCode: {
      formSubtitle: 'আপনার ইমেইল ঠিকানায় পাঠানো যাচাইকরণ কোড লিখুন',
      formTitle: 'যাচাইকরণ কোড',
      resendButton: 'কোনো কোড পাননি? পুনরায় পাঠান',
      subtitle: 'আপনার ইমেইলে পাঠানো যাচাইকরণ কোড লিখুন',
      title: 'আপনার ইমেইল যাচাই করুন',
    },
    emailLink: {
      clientMismatch: {
        subtitle: 'চালিয়ে যেতে, যে ডিভাইস এবং ব্রাউজার থেকে আপনি সাইন-আপ শুরু করেছেন সেখানে যাচাইকরণ লিংক খুলুন',
        title: 'এই ডিভাইসের জন্য যাচাইকরণ লিংক অবৈধ',
      },
      formSubtitle: 'আপনার ইমেইল ঠিকানায় পাঠানো যাচাইকরণ লিংক ব্যবহার করুন',
      formTitle: 'যাচাইকরণ লিংক',
      loading: {
        title: 'সাইন আপ করা হচ্ছে...',
      },
      resendButton: 'কোনো লিংক পাননি? পুনরায় পাঠান',
      subtitle: '{{applicationName}}-এ চালিয়ে যাওয়ার জন্য',
      title: 'আপনার ইমেইল যাচাই করুন',
      verified: {
        title: 'সফলভাবে সাইন আপ হয়েছে',
      },
      verifiedSwitchTab: {
        subtitle: 'চালিয়ে যেতে নতুন খোলা ট্যাবে ফিরে যান',
        subtitleNewTab: 'চালিয়ে যেতে আগের ট্যাবে ফিরে যান',
        title: 'সফলভাবে ইমেইল যাচাই করা হয়েছে',
      },
    },
    enterpriseConnections: {
      subtitle: undefined,
      title: undefined,
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: 'আমি {{ privacyPolicyLink || link("গোপনীয়তা নীতি") }}-এর সাথে সম্মত',
        label__onlyTermsOfService: 'আমি {{ termsOfServiceLink || link("সেবার শর্তাবলী") }}-এর সাথে সম্মত',
        label__termsOfServiceAndPrivacyPolicy:
          'আমি {{ termsOfServiceLink || link("সেবার শর্তাবলী") }} এবং {{ privacyPolicyLink || link("গোপনীয়তা নীতি") }}-এর সাথে সম্মত',
      },
      continue: {
        subtitle: 'চালিয়ে যেতে দয়া করে শর্তাবলী পড়ুন এবং স্বীকার করুন',
        title: 'আইনি সম্মতি',
      },
    },
    phoneCode: {
      formSubtitle: 'আপনার ফোন নম্বরে পাঠানো যাচাইকরণ কোড লিখুন',
      formTitle: 'যাচাইকরণ কোড',
      resendButton: 'কোনো কোড পাননি? পুনরায় পাঠান',
      subtitle: 'আপনার ফোনে পাঠানো যাচাইকরণ কোড লিখুন',
      title: 'আপনার ফোন যাচাই করুন',
    },
    restrictedAccess: {
      actionLink: 'সাইন ইন করুন',
      actionText: 'ইতিমধ্যে একটি অ্যাকাউন্ট আছে?',
      blockButton__emailSupport: 'ইমেইল সাপোর্ট',
      blockButton__joinWaitlist: 'ওয়েটলিস্টে যোগ দিন',
      subtitle:
        'সাইন আপ বর্তমানে অক্ষম। আপনি যদি মনে করেন আপনার অ্যাক্সেস থাকা উচিত, দয়া করে সাপোর্টের সাথে যোগাযোগ করুন।',
      subtitleWaitlist: 'সাইন আপ বর্তমানে অক্ষম। আমরা যখন লঞ্চ করব তখন প্রথম জানতে, ওয়েটলিস্টে যোগ দিন।',
      title: 'অ্যাক্সেস সীমিত',
    },
    start: {
      actionLink: 'সাইন ইন করুন',
      actionLink__use_email: 'পরিবর্তে ইমেইল ব্যবহার করুন',
      actionLink__use_phone: 'পরিবর্তে ফোন ব্যবহার করুন',
      actionText: 'ইতিমধ্যে একটি অ্যাকাউন্ট আছে?',
      alternativePhoneCodeProvider: {
        actionLink: undefined,
        label: undefined,
        subtitle: undefined,
        title: undefined,
      },
      subtitle: 'স্বাগতম! শুরু করতে দয়া করে তথ্য পূরণ করুন।',
      subtitleCombined: 'স্বাগতম! শুরু করতে দয়া করে তথ্য পূরণ করুন।',
      title: 'আপনার অ্যাকাউন্ট তৈরি করুন',
      titleCombined: 'আপনার অ্যাকাউন্ট তৈরি করুন',
    },
    web3Solana: {
      subtitle: 'সাইন আপ করতে নিচে একটি ওয়ালেট নির্বাচন করুন',
      title: 'Solana দিয়ে সাইন আপ করুন',
    },
  },
  socialButtonsBlockButton: '{{provider|titleize}} দিয়ে চালিয়ে যান',
  socialButtonsBlockButtonManyInView: '{{provider|titleize}}',
  taskChooseOrganization: {
    chooseOrganization: {
      action__createOrganization: undefined,
      action__invitationAccept: undefined,
      action__suggestionsAccept: undefined,
      subtitle: undefined,
      subtitle__createOrganizationDisabled: undefined,
      suggestionsAcceptedLabel: undefined,
      title: undefined,
    },
    createOrganization: {
      formButtonReset: undefined,
      formButtonSubmit: undefined,
      formFieldInputPlaceholder__name: undefined,
      formFieldInputPlaceholder__slug: undefined,
      formFieldLabel__name: undefined,
      formFieldLabel__slug: undefined,
      subtitle: undefined,
      title: undefined,
    },
    organizationCreationDisabled: {
      title: 'আপনাকে অবশ্যই একটি সংগঠনের অন্তর্ভুক্ত হতে হবে',
      subtitle: 'আমন্ত্রণের জন্য আপনার সংগঠনের প্রশাসকের সাথে যোগাযোগ করুন।',
    },
    signOut: {
      actionLink: undefined,
      actionText: undefined,
    },
    alerts: {
      organizationAlreadyExists:
        'শনাক্ত করা কোম্পানির নাম ({{organizationName}}) এবং {{organizationDomain}}-এর জন্য একটি সংস্থা ইতিমধ্যেই বিদ্যমান। আমন্ত্রণের মাধ্যমে যোগ দিন।',
    },
  },
  taskResetPassword: {
    formButtonPrimary: undefined,
    signOut: {
      actionLink: undefined,
      actionText: undefined,
    },
    subtitle: undefined,
    title: undefined,
  },
  unstable__errors: {
    already_a_member_in_organization: '{{email}} ইতিমধ্যে সংগঠনের একজন সদস্য।',
    avatar_file_size_exceeded: 'ফাইলের আকার সর্বোচ্চ ১০ এমবি সীমা অতিক্রম করেছে। দয়া করে একটি ছোট ফাইল নির্বাচন করুন।',
    avatar_file_type_invalid: 'ফাইলের ধরন সমর্থিত নয়। দয়া করে JPG, PNG, GIF বা WEBP ছবি আপলোড করুন।',
    captcha_invalid:
      'নিরাপত্তা যাচাইকরণ ব্যর্থ হওয়ার কারণে সাইন আপ ব্যর্থ হয়েছে। আবার চেষ্টা করতে দয়া করে পৃষ্ঠাটি রিফ্রেশ করুন বা আরও সাহায্যের জন্য সাপোর্টের সাথে যোগাযোগ করুন।',
    captcha_unavailable:
      'বট যাচাইকরণ ব্যর্থ হওয়ার কারণে সাইন আপ ব্যর্থ হয়েছে। আবার চেষ্টা করতে দয়া করে পৃষ্ঠাটি রিফ্রেশ করুন বা আরও সাহায্যের জন্য সাপোর্টের সাথে যোগাযোগ করুন।',
    form_code_incorrect: undefined,
    form_email_address_blocked:
      'অস্থায়ী ইমেইল পরিষেবাগুলি সমর্থিত নয়। অনুগ্রহ করে অ্যাকাউন্ট তৈরি করতে আপনার নিয়মিত ইমেইল ঠিকানা ব্যবহার করুন।',
    form_identifier_exists__email_address: 'এই ইমেইল ঠিকানা ব্যবহৃত হয়েছে। দয়া করে অন্য একটি ব্যবহার করুন।',
    form_identifier_exists__phone_number: 'এই ফোন নম্বর ব্যবহৃত হয়েছে। দয়া করে অন্য একটি ব্যবহার করুন।',
    form_identifier_exists__username: 'এই ব্যবহারকারীর নাম ব্যবহৃত হয়েছে। দয়া করে অন্য একটি ব্যবহার করুন।',
    form_identifier_not_found:
      'এই শনাক্তকারী দিয়ে কোনো অ্যাকাউন্ট পাওয়া যায়নি। দয়া করে চেক করুন এবং আবার চেষ্টা করুন।',
    form_new_password_matches_current: undefined,
    form_param_format_invalid: 'লেখা মানটি একটি অবৈধ ফরম্যাটে আছে। দয়া করে চেক করুন এবং সংশোধন করুন।',
    form_param_format_invalid__email_address: 'ইমেইল ঠিকানা একটি বৈধ ইমেইল ঠিকানা হতে হবে।',
    form_param_format_invalid__phone_number: 'ফোন নম্বর একটি বৈধ আন্তর্জাতিক ফরম্যাটে হতে হবে।',
    form_param_max_length_exceeded__first_name: 'নামের প্রথম অংশ ২৫৬ অক্ষরের বেশি হওয়া উচিত নয়।',
    form_param_max_length_exceeded__last_name: 'নামের শেষ অংশ ২৫৬ অক্ষরের বেশি হওয়া উচিত নয়।',
    form_param_max_length_exceeded__name: 'নাম ২৫৬ অক্ষরের বেশি হওয়া উচিত নয়।',
    form_param_nil: 'এই ক্ষেত্রটি প্রয়োজনীয় এবং খালি রাখা যাবে না।',
    form_param_type_invalid: undefined,
    form_param_type_invalid__email_address: undefined,
    form_param_type_invalid__phone_number: undefined,
    form_param_value_invalid: 'লেখা মানটি অবৈধ। দয়া করে এটি সংশোধন করুন।',
    form_password_incorrect: 'আপনি যে পাসওয়ার্ড লিখেছেন তা ভুল। দয়া করে আবার চেষ্টা করুন।',
    form_password_or_identifier_incorrect:
      'পাসওয়ার্ড বা ইমেইল ঠিকানা ভুল। আবার চেষ্টা করুন বা অন্য পদ্ধতি ব্যবহার করুন।',
    form_password_length_too_short: 'আপনার পাসওয়ার্ড খুব ছোট। এটি কমপক্ষে ৮ অক্ষর দীর্ঘ হতে হবে।',
    form_password_not_strong_enough: 'আপনার পাসওয়ার্ড যথেষ্ট শক্তিশালী নয়।',
    form_password_pwned:
      'এই পাসওয়ার্ডটি একটি ডেটা লঙ্ঘনের অংশ হিসাবে পাওয়া গেছে এবং ব্যবহার করা যাবে না, দয়া করে অন্য একটি পাসওয়ার্ড ব্যবহার করুন।',
    form_password_pwned__sign_in:
      'এই পাসওয়ার্ডটি একটি ডেটা লঙ্ঘনের অংশ হিসাবে পাওয়া গেছে এবং ব্যবহার করা যাবে না, দয়া করে আপনার পাসওয়ার্ড রিসেট করুন।',
    form_password_size_in_bytes_exceeded:
      'আপনার পাসওয়ার্ড অনুমোদিত সর্বাধিক বাইট সংখ্যা অতিক্রম করেছে, দয়া করে এটি ছোট করুন বা কিছু বিশেষ অক্ষর সরান।',
    form_password_untrusted__sign_in: undefined,
    form_password_validation_failed: 'ভুল পাসওয়ার্ড',
    form_username_invalid_character:
      'আপনার ব্যবহারকারীর নামে অবৈধ অক্ষর রয়েছে। দয়া করে শুধুমাত্র অক্ষর, সংখ্যা এবং আন্ডারস্কোর ব্যবহার করুন।',
    form_username_invalid_length: 'আপনার ব্যবহারকারীর নাম {{min_length}} থেকে {{max_length}} অক্ষর দীর্ঘ হতে হবে।',
    form_username_needs_non_number_char: 'আপনার ব্যবহারকারীর নামে কমপক্ষে একটি অ-সংখ্যাসূচক অক্ষর থাকতে হবে।',
    identification_deletion_failed: 'আপনি আপনার শেষ শনাক্তকরণ মুছতে পারবেন না।',
    not_allowed_access:
      'আপনার এই পৃষ্ঠা অ্যাক্সেস করার অনুমতি নেই। আপনি যদি মনে করেন এটি একটি ত্রুটি, দয়া করে সাপোর্টের সাথে যোগাযোগ করুন।',
    organization_domain_blocked: 'এটি একটি ব্লক করা ইমেইল প্রদানকারী ডোমেন। দয়া করে একটি ভিন্ন ব্যবহার করুন।',
    organization_domain_common: 'এটি একটি সাধারণ ইমেইল প্রদানকারী ডোমেন। দয়া করে একটি ভিন্ন ব্যবহার করুন।',
    organization_domain_exists_for_enterprise_connection: 'এই ডোমেন ইতিমধ্যে আপনার সংগঠনের SSO-এর জন্য ব্যবহৃত হচ্ছে',
    organization_membership_quota_exceeded: 'আপনি অপেক্ষিত আমন্ত্রণ সহ সংগঠনের সদস্যতার সীমায় পৌঁছে গেছেন।',
    organization_minimum_permissions_needed: 'অন্তত একজন সংগঠনের সদস্যের ন্যূনতম প্রয়োজনীয় অনুমতি থাকতে হবে।',
    organization_not_found_or_unauthorized: undefined,
    organization_not_found_or_unauthorized_with_create_organization_disabled: undefined,
    passkey_already_exists: 'এই ডিভাইসে ইতিমধ্যে একটি পাসকি নিবন্ধিত আছে।',
    passkey_not_supported: 'এই ডিভাইসে পাসকি সমর্থিত নয়।',
    passkey_pa_not_supported:
      'রেজিস্ট্রেশনের জন্য একটি প্ল্যাটফর্ম অথেনটিকেটর প্রয়োজন কিন্তু ডিভাইসটি এটি সমর্থন করে না।',
    passkey_registration_cancelled: 'পাসকি রেজিস্ট্রেশন বাতিল করা হয়েছে বা সময় শেষ হয়ে গেছে।',
    passkey_retrieval_cancelled: 'পাসকি যাচাইকরণ বাতিল করা হয়েছে বা সময় শেষ হয়ে গেছে।',
    passwordComplexity: {
      maximumLength: '{{length}} অক্ষরের কম',
      minimumLength: '{{length}} বা তার বেশি অক্ষর',
      requireLowercase: 'একটি ছোট হাতের অক্ষর',
      requireNumbers: 'একটি সংখ্যা',
      requireSpecialCharacter: 'একটি বিশেষ অক্ষর',
      requireUppercase: 'একটি বড় হাতের অক্ষর',
      sentencePrefix: 'আপনার পাসওয়ার্ডে অবশ্যই থাকতে হবে',
    },
    phone_number_exists: 'এই ফোন নম্বর ব্যবহৃত হয়েছে। দয়া করে অন্য একটি ব্যবহার করুন।',
    session_exists: undefined,
    web3_missing_identifier: 'একটি Web3 ওয়ালেট এক্সটেনশন পাওয়া যায়নি। চালিয়ে যেতে দয়া করে একটি ইনস্টল করুন।',
    web3_signature_request_rejected:
      'আপনি সিগনেচার অনুরোধটি প্রত্যাখ্যান করেছেন। চালিয়ে যেতে অনুগ্রহ করে আবার চেষ্টা করুন।',
    web3_solana_signature_generation_failed:
      'সিগনেচার তৈরি করার সময় একটি ত্রুটি ঘটেছে। চালিয়ে যেতে অনুগ্রহ করে আবার চেষ্টা করুন।',
    zxcvbn: {
      couldBeStronger: 'আপনার পাসওয়ার্ড কাজ করে, কিন্তু আরও শক্তিশালী হতে পারে। আরও অক্ষর যোগ করার চেষ্টা করুন।',
      goodPassword: 'আপনার পাসওয়ার্ড সমস্ত প্রয়োজনীয় শর্ত পূরণ করে।',
      notEnough: 'আপনার পাসওয়ার্ড যথেষ্ট শক্তিশালী নয়।',
      suggestions: {
        allUppercase: 'কিছু অক্ষর, কিন্তু সবগুলি নয়, বড় হাতের করুন।',
        anotherWord: 'আরও বেশি শব্দ যোগ করুন যা কম সাধারণ।',
        associatedYears: 'আপনার সাথে সম্পর্কিত বছরগুলি এড়িয়ে চলুন।',
        capitalization: 'প্রথম অক্ষরের চেয়ে বেশি বড় হাতে লিখুন।',
        dates: 'আপনার সাথে সম্পর্কিত তারিখ এবং বছর এড়িয়ে চলুন।',
        l33t: "'a' এর জন্য '@' এর মতো অনুমানযোগ্য অক্ষর প্রতিস্থাপন এড়িয়ে চলুন।",
        longerKeyboardPattern: 'দীর্ঘ কীবোর্ড প্যাটার্ন ব্যবহার করুন এবং বারবার টাইপিং দিক পরিবর্তন করুন।',
        noNeed: 'আপনি প্রতীক, সংখ্যা বা বড় হাতের অক্ষর ছাড়াই শক্তিশালী পাসওয়ার্ড তৈরি করতে পারেন।',
        pwned: 'আপনি যদি এই পাসওয়ার্ডটি অন্য কোথাও ব্যবহার করেন, তাহলে আপনার এটি পরিবর্তন করা উচিত।',
        recentYears: 'সাম্প্রতিক বছরগুলি এড়িয়ে চলুন।',
        repeated: 'পুনরাবৃত্ত শব্দ এবং অক্ষর এড়িয়ে চলুন।',
        reverseWords: 'সাধারণ শব্দের উল্টো বানান এড়িয়ে চলুন।',
        sequences: 'সাধারণ অক্ষর সিকোয়েন্স এড়িয়ে চলুন।',
        useWords: 'একাধিক শব্দ ব্যবহার করুন, কিন্তু সাধারণ বাক্যাংশ এড়িয়ে চলুন।',
      },
      warnings: {
        common: 'এটি একটি সাধারণভাবে ব্যবহৃত পাসওয়ার্ড।',
        commonNames: 'সাধারণ নাম এবং পদবি সহজেই অনুমান করা যায়।',
        dates: 'তারিখগুলি সহজেই অনুমান করা যায়।',
        extendedRepeat: '"abcabcabc" এর মতো পুনরাবৃত্ত অক্ষর প্যাটার্ন সহজেই অনুমান করা যায়।',
        keyPattern: 'ছোট কীবোর্ড প্যাটার্ন সহজেই অনুমান করা যায়।',
        namesByThemselves: 'একক নাম বা পদবি সহজেই অনুমান করা যায়।',
        pwned: 'আপনার পাসওয়ার্ড ইন্টারনেটে একটি ডেটা লঙ্ঘনের মাধ্যমে প্রকাশিত হয়েছে।',
        recentYears: 'সাম্প্রতিক বছরগুলি সহজেই অনুমান করা যায়।',
        sequences: '"abc" এর মতো সাধারণ অক্ষর সিকোয়েন্স সহজেই অনুমান করা যায়।',
        similarToCommon: 'এটি একটি সাধারণভাবে ব্যবহৃত পাসওয়ার্ডের সাথে সাদৃশ্যপূর্ণ।',
        simpleRepeat: '"aaa" এর মতো পুনরাবৃত্ত অক্ষর সহজেই অনুমান করা যায়।',
        straightRow: 'আপনার কীবোর্ডের সরাসরি সারি সহজেই অনুমান করা যায়।',
        topHundred: 'এটি একটি প্রায়শই ব্যবহৃত পাসওয়ার্ড।',
        topTen: 'এটি একটি অত্যধিক ব্যবহৃত পাসওয়ার্ড।',
        userInputs: 'কোনো ব্যক্তিগত বা পৃষ্ঠা সম্পর্কিত তথ্য থাকা উচিত নয়।',
        wordByItself: 'একক শব্দ সহজেই অনুমান করা যায়।',
      },
    },
  },
  userButton: {
    action__addAccount: 'অ্যাকাউন্ট যোগ করুন',
    action__closeUserMenu: 'ব্যবহারকারী মেনু বন্ধ করুন',
    action__manageAccount: 'অ্যাকাউন্ট পরিচালনা করুন',
    action__openUserMenu: 'ব্যবহারকারী মেনু খুলুন',
    action__signOut: 'সাইন আউট',
    action__signOutAll: 'সব অ্যাকাউন্ট থেকে সাইন আউট করুন',
  },
  userProfile: {
    apiKeysPage: {
      title: undefined,
    },
    backupCodePage: {
      actionLabel__copied: 'কপি করা হয়েছে!',
      actionLabel__copy: 'সবগুলি কপি করুন',
      actionLabel__download: '.txt ডাউনলোড করুন',
      actionLabel__print: 'প্রিন্ট করুন',
      infoText1: 'এই অ্যাকাউন্টের জন্য ব্যাকআপ কোড সক্ষম করা হবে।',
      infoText2:
        'ব্যাকআপ কোডগুলি গোপন রাখুন এবং নিরাপদে সংরক্ষণ করুন। আপনি যদি সন্দেহ করেন যে সেগুলি সমঝোতা হয়েছে, তাহলে ব্যাকআপ কোডগুলি পুনর্জন্ম করতে পারেন।',
      subtitle__codelist: 'সেগুলি নিরাপদে সংরক্ষণ করুন এবং গোপন রাখুন।',
      successMessage:
        'ব্যাকআপ কোড এখন সক্ষম করা হয়েছে। আপনি যদি আপনার অথেনটিকেশন ডিভাইসের অ্যাক্সেস হারান, তাহলে আপনার অ্যাকাউন্টে সাইন ইন করতে এর মধ্যে একটি ব্যবহার করতে পারেন। প্রতিটি কোড শুধুমাত্র একবার ব্যবহার করা যেতে পারে।',
      successSubtitle:
        'আপনি যদি আপনার অথেনটিকেশন ডিভাইসের অ্যাক্সেস হারান, তাহলে আপনার অ্যাকাউন্টে সাইন ইন করতে এর মধ্যে একটি ব্যবহার করতে পারেন।',
      title: 'ব্যাকআপ কোড যাচাইকরণ যোগ করুন',
      title__codelist: 'ব্যাকআপ কোড',
    },
    billingPage: {
      paymentHistorySection: {
        empty: undefined,
        notFound: undefined,
        tableHeader__amount: undefined,
        tableHeader__date: undefined,
        tableHeader__status: undefined,
      },
      paymentMethodsSection: {
        actionLabel__default: undefined,
        actionLabel__remove: undefined,
        add: undefined,
        addSubtitle: undefined,
        cancelButton: undefined,
        formButtonPrimary__add: undefined,
        formButtonPrimary__pay: undefined,
        payWithTestCardButton: undefined,
        removeMethod: {
          messageLine1: undefined,
          messageLine2: undefined,
          successMessage: undefined,
          title: undefined,
        },
        title: undefined,
      },
      start: {
        headerTitle__payments: undefined,
        headerTitle__plans: undefined,
        headerTitle__statements: undefined,
        headerTitle__subscriptions: undefined,
      },
      statementsSection: {
        empty: undefined,
        itemCaption__paidForPlan: undefined,
        itemCaption__proratedCredit: undefined,
        itemCaption__subscribedAndPaidForPlan: undefined,
        notFound: undefined,
        tableHeader__amount: undefined,
        tableHeader__date: undefined,
        title: undefined,
        totalPaid: undefined,
      },
      subscriptionsListSection: {
        actionLabel__manageSubscription: undefined,
        actionLabel__newSubscription: undefined,
        actionLabel__switchPlan: undefined,
        tableHeader__edit: undefined,
        tableHeader__plan: undefined,
        tableHeader__startDate: undefined,
        title: undefined,
      },
      subscriptionsSection: {
        actionLabel__default: undefined,
      },
      switchPlansSection: {
        title: undefined,
      },
      title: undefined,
    },
    connectedAccountPage: {
      formHint: 'আপনার অ্যাকাউন্ট সংযুক্ত করার জন্য একটি প্রদানকারী নির্বাচন করুন।',
      formHint__noAccounts: 'কোনো উপলব্ধ বাহ্যিক অ্যাকাউন্ট প্রদানকারী নেই।',
      removeResource: {
        messageLine1: '{{identifier}} এই অ্যাকাউন্ট থেকে সরানো হবে।',
        messageLine2:
          'আপনি আর এই সংযুক্ত অ্যাকাউন্ট ব্যবহার করতে পারবেন না এবং কোনো নির্ভরশীল বৈশিষ্ট্য আর কাজ করবে না।',
        successMessage: '{{connectedAccount}} আপনার অ্যাকাউন্ট থেকে সরানো হয়েছে।',
        title: 'সংযুক্ত অ্যাকাউন্ট সরান',
      },
      socialButtonsBlockButton: '{{provider|titleize}}',
      successMessage: 'প্রদানকারী আপনার অ্যাকাউন্টে যোগ করা হয়েছে',
      title: 'সংযুক্ত অ্যাকাউন্ট যোগ করুন',
    },
    deletePage: {
      actionDescription: 'চালিয়ে যেতে নীচে "Delete account" টাইপ করুন।',
      confirm: 'অ্যাকাউন্ট মুছুন',
      messageLine1:
        'আপনি কি নিশ্চিত যে আপনি আপনার অ্যাকাউন্ট মুছে ফেলতে চান? কিছু সংশ্লিষ্ট ডেটা ধরে রাখা হতে পারে। সম্পূর্ণ ডেটা মুছে ফেলার অনুরোধ করতে, অনুগ্রহ করে সহায়তার সাথে যোগাযোগ করুন।',
      messageLine2: 'এই কার্যটি স্থায়ী এবং অপরিবর্তনীয়।',
      title: 'অ্যাকাউন্ট মুছুন',
    },
    emailAddressPage: {
      emailCode: {
        formHint: 'এই ইমেইল ঠিকানায় একটি যাচাইকরণ কোড সহ একটি ইমেইল পাঠানো হবে।',
        formSubtitle: '{{identifier}}-এ পাঠানো যাচাইকরণ কোড লিখুন',
        formTitle: 'যাচাইকরণ কোড',
        resendButton: 'কোনো কোড পাননি? পুনরায় পাঠান',
        successMessage: 'ইমেইল {{identifier}} আপনার অ্যাকাউন্টে যোগ করা হয়েছে।',
      },
      emailLink: {
        formHint: 'এই ইমেইল ঠিকানায় একটি যাচাইকরণ লিংক সহ একটি ইমেইল পাঠানো হবে।',
        formSubtitle: '{{identifier}}-এ পাঠানো ইমেইলের যাচাইকরণ লিংকে ক্লিক করুন',
        formTitle: 'যাচাইকরণ লিংক',
        resendButton: 'কোনো লিংক পাননি? পুনরায় পাঠান',
        successMessage: 'ইমেইল {{identifier}} আপনার অ্যাকাউন্টে যোগ করা হয়েছে।',
      },
      enterpriseSSOLink: {
        formButton: 'সাইন-ইন করতে ক্লিক করুন',
        formSubtitle: '{{identifier}} দিয়ে সাইন-ইন সম্পূর্ণ করুন',
      },
      formHint: 'আপনার অ্যাকাউন্টে যোগ করার আগে এই ইমেইল ঠিকানা যাচাই করতে হবে।',
      removeResource: {
        messageLine1: '{{identifier}} এই অ্যাকাউন্ট থেকে সরানো হবে।',
        messageLine2: 'আপনি আর এই ইমেইল ঠিকানা ব্যবহার করে সাইন ইন করতে পারবেন না।',
        successMessage: '{{emailAddress}} আপনার অ্যাকাউন্ট থেকে সরানো হয়েছে।',
        title: 'ইমেইল ঠিকানা সরান',
      },
      title: 'ইমেইল ঠিকানা যোগ করুন',
      verifyTitle: 'ইমেইল ঠিকানা যাচাই করুন',
    },
    formButtonPrimary__add: 'যোগ করুন',
    formButtonPrimary__continue: 'চালিয়ে যান',
    formButtonPrimary__finish: 'শেষ করুন',
    formButtonPrimary__remove: 'সরান',
    formButtonPrimary__save: 'সংরক্ষণ করুন',
    formButtonReset: 'বাতিল করুন',
    mfaPage: {
      formHint: 'যোগ করার জন্য একটি পদ্ধতি নির্বাচন করুন।',
      title: 'দুই-ধাপ যাচাইকরণ যোগ করুন',
    },
    mfaPhoneCodePage: {
      backButton: 'বিদ্যমান নম্বর ব্যবহার করুন',
      primaryButton__addPhoneNumber: 'ফোন নম্বর যোগ করুন',
      removeResource: {
        messageLine1: '{{identifier}} আর সাইন ইন করার সময় যাচাইকরণ কোড পাবে না।',
        messageLine2: 'আপনার অ্যাকাউন্ট হয়তো তেমন নিরাপদ নাও থাকতে পারে। আপনি কি চালিয়ে যেতে চান?',
        successMessage: '{{mfaPhoneCode}}-এর জন্য এসএমএস কোড দুই-ধাপ যাচাইকরণ সরানো হয়েছে',
        title: 'দুই-ধাপ যাচাইকরণ সরান',
      },
      subtitle__availablePhoneNumbers:
        'এসএমএস কোড দুই-ধাপ যাচাইকরণের জন্য একটি বিদ্যমান ফোন নম্বর নির্বাচন করুন অথবা একটি নতুন যোগ করুন।',
      subtitle__unavailablePhoneNumbers:
        'এসএমএস কোড দুই-ধাপ যাচাইকরণের জন্য কোনো উপলব্ধ ফোন নম্বর নেই, দয়া করে একটি নতুন যোগ করুন।',
      successMessage1:
        'সাইন ইন করার সময়, আপনাকে একটি অতিরিক্ত ধাপ হিসাবে এই ফোন নম্বরে পাঠানো একটি যাচাইকরণ কোড লিখতে হবে।',
      successMessage2:
        'এই ব্যাকআপ কোডগুলি সংরক্ষণ করুন এবং সেগুলি কোথাও নিরাপদে রাখুন। আপনি যদি আপনার অথেনটিকেশন ডিভাইসের অ্যাক্সেস হারান, তাহলে সাইন ইন করতে ব্যাকআপ কোড ব্যবহার করতে পারেন।',
      successTitle: 'এসএমএস কোড যাচাইকরণ সক্ষম করা হয়েছে',
      title: 'এসএমএস কোড যাচাইকরণ যোগ করুন',
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: 'পরিবর্তে QR কোড স্ক্যান করুন',
        buttonUnableToScan__nonPrimary: 'QR কোড স্ক্যান করতে পারছেন না?',
        infoText__ableToScan:
          'আপনার অথেনটিকেটর অ্যাপে একটি নতুন সাইন-ইন পদ্ধতি সেট আপ করুন এবং আপনার অ্যাকাউন্টের সাথে লিঙ্ক করতে নিম্নলিখিত QR কোড স্ক্যান করুন।',
        infoText__unableToScan: 'আপনার অথেনটিকেটরে একটি নতুন সাইন-ইন পদ্ধতি সেট আপ করুন এবং নীচে প্রদত্ত কী লিখুন।',
        inputLabel__unableToScan1:
          'নিশ্চিত করুন যে সময়-ভিত্তিক বা ওয়ান-টাইম পাসওয়ার্ড সক্ষম করা আছে, তারপর আপনার অ্যাকাউন্ট লিঙ্ক করা শেষ করুন।',
        inputLabel__unableToScan2:
          'বিকল্পভাবে, আপনার অথেনটিকেটর যদি TOTP URI সমর্থন করে, তাহলে আপনি সম্পূর্ণ URI-ও কপি করতে পারেন।',
      },
      removeResource: {
        messageLine1: 'সাইন ইন করার সময় এই অথেনটিকেটর থেকে যাচাইকরণ কোড আর প্রয়োজন হবে না।',
        messageLine2: 'আপনার অ্যাকাউন্ট হয়তো তেমন নিরাপদ নাও থাকতে পারে। আপনি কি চালিয়ে যেতে চান?',
        successMessage: 'অথেনটিকেটর অ্যাপ্লিকেশনের মাধ্যমে দুই-ধাপ যাচাইকরণ সরানো হয়েছে।',
        title: 'দুই-ধাপ যাচাইকরণ সরান',
      },
      successMessage:
        'দুই-ধাপ যাচাইকরণ এখন সক্ষম করা হয়েছে। সাইন ইন করার সময়, আপনাকে একটি অতিরিক্ত ধাপ হিসাবে এই অথেনটিকেটর থেকে একটি যাচাইকরণ কোড লিখতে হবে।',
      title: 'অথেনটিকেটর অ্যাপ্লিকেশন যোগ করুন',
      verifySubtitle: 'আপনার অথেনটিকেটর দ্বারা উৎপন্ন যাচাইকরণ কোড লিখুন',
      verifyTitle: 'যাচাইকরণ কোড',
    },
    mobileButton__menu: 'মেনু',
    navbar: {
      account: 'প্রোফাইল',
      apiKeys: undefined,
      billing: 'বিলিং',
      description: 'আপনার অ্যাকাউন্টের তথ্য পরিচালনা করুন।',
      security: 'নিরাপত্তা',
      title: 'অ্যাকাউন্ট',
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: '{{name}} এই অ্যাকাউন্ট থেকে সরানো হবে।',
        title: 'পাসকি সরান',
      },
      subtitle__rename: 'আপনি পাসকি নাম পরিবর্তন করতে পারেন যাতে এটি সহজে খুঁজে পাওয়া যায়।',
      title__rename: 'পাসকি পুনঃনামকরণ করুন',
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions:
        'এটি সুপারিশ করা হয় যে আপনি অন্য সব ডিভাইস থেকে সাইন আউট করুন যেগুলিতে আপনার পুরানো পাসওয়ার্ড ব্যবহার করা হয়েছে।',
      readonly:
        'আপনার পাসওয়ার্ড বর্তমানে সম্পাদনা করা যাবে না কারণ আপনি শুধুমাত্র এন্টারপ্রাইজ সংযোগের মাধ্যমে সাইন ইন করতে পারেন।',
      successMessage__set: 'আপনার পাসওয়ার্ড সেট করা হয়েছে।',
      successMessage__signOutOfOtherSessions: 'অন্য সব ডিভাইস থেকে সাইন আউট করা হয়েছে।',
      successMessage__update: 'আপনার পাসওয়ার্ড আপডেট করা হয়েছে।',
      title__set: 'পাসওয়ার্ড সেট করুন',
      title__update: 'পাসওয়ার্ড আপডেট করুন',
    },
    phoneNumberPage: {
      infoText:
        'এই ফোন নম্বরে একটি যাচাইকরণ কোড সহ একটি টেক্সট মেসেজ পাঠানো হবে। মেসেজ এবং ডেটা রেট প্রযোজ্য হতে পারে।',
      removeResource: {
        messageLine1: '{{identifier}} এই অ্যাকাউন্ট থেকে সরানো হবে।',
        messageLine2: 'আপনি আর এই ফোন নম্বর ব্যবহার করে সাইন ইন করতে পারবেন না।',
        successMessage: '{{phoneNumber}} আপনার অ্যাকাউন্ট থেকে সরানো হয়েছে।',
        title: 'ফোন নম্বর সরান',
      },
      successMessage: '{{identifier}} আপনার অ্যাকাউন্টে যোগ করা হয়েছে।',
      title: 'ফোন নম্বর যোগ করুন',
      verifySubtitle: '{{identifier}}-এ পাঠানো যাচাইকরণ কোড লিখুন',
      verifyTitle: 'ফোন নম্বর যাচাই করুন',
    },
    plansPage: {
      title: undefined,
    },
    profilePage: {
      fileDropAreaHint: 'সুপারিশকৃত আকার 1:1, 10MB পর্যন্ত।',
      imageFormDestructiveActionSubtitle: 'সরান',
      imageFormSubtitle: 'আপলোড',
      imageFormTitle: 'প্রোফাইল ছবি',
      readonly: 'আপনার প্রোফাইল তথ্য এন্টারপ্রাইজ সংযোগ দ্বারা প্রদান করা হয়েছে এবং সম্পাদনা করা যাবে না।',
      successMessage: 'আপনার প্রোফাইল আপডেট করা হয়েছে।',
      title: 'প্রোফাইল আপডেট করুন',
    },
    start: {
      activeDevicesSection: {
        destructiveAction: 'ডিভাইস থেকে সাইন আউট করুন',
        title: 'সক্রিয় ডিভাইস',
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: 'পুনরায় সংযোগ করুন',
        actionLabel__reauthorize: 'এখনই অনুমোদন করুন',
        destructiveActionTitle: 'সরান',
        primaryButton: 'অ্যাকাউন্ট সংযুক্ত করুন',
        subtitle__disconnected: 'এই অ্যাকাউন্টের সংযোগ বিচ্ছিন্ন করা হয়েছে।',
        subtitle__reauthorize:
          'প্রয়োজনীয় স্কোপগুলি আপডেট করা হয়েছে, এবং আপনি সীমিত কার্যকারিতা অনুভব করতে পারেন। কোনো সমস্যা এড়াতে দয়া করে এই অ্যাপ্লিকেশনকে পুনরায় অনুমোদন করুন',
        title: 'সংযুক্ত অ্যাকাউন্ট',
      },
      dangerSection: {
        deleteAccountButton: 'অ্যাকাউন্ট মুছুন',
        title: 'অ্যাকাউন্ট মুছুন',
      },
      emailAddressesSection: {
        destructiveAction: 'ইমেইল সরান',
        detailsAction__nonPrimary: 'প্রাথমিক হিসাবে সেট করুন',
        detailsAction__primary: 'যাচাইকরণ সম্পন্ন করুন',
        detailsAction__unverified: 'যাচাই করুন',
        primaryButton: 'ইমেইল ঠিকানা যোগ করুন',
        title: 'ইমেইল ঠিকানা',
      },
      enterpriseAccountsSection: {
        title: 'এন্টারপ্রাইজ অ্যাকাউন্ট',
      },
      headerTitle__account: 'প্রোফাইল বিবরণ',
      headerTitle__security: 'নিরাপত্তা',
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: 'পুনর্জন্ম করুন',
          headerTitle: 'ব্যাকআপ কোড',
          subtitle__regenerate:
            'নতুন সুরক্ষিত ব্যাকআপ কোড পান। আগের ব্যাকআপ কোডগুলি মুছে ফেলা হবে এবং ব্যবহার করা যাবে না।',
          title__regenerate: 'ব্যাকআপ কোড পুনর্জন্ম করুন',
        },
        phoneCode: {
          actionLabel__setDefault: 'ডিফল্ট হিসাবে সেট করুন',
          destructiveActionLabel: 'সরান',
        },
        primaryButton: 'দুই-ধাপ যাচাইকরণ যোগ করুন',
        title: 'দুই-ধাপ যাচাইকরণ',
        totp: {
          destructiveActionTitle: 'সরান',
          headerTitle: 'অথেনটিকেটর অ্যাপ্লিকেশন',
        },
      },
      passkeysSection: {
        menuAction__destructive: 'সরান',
        menuAction__rename: 'পুনঃনামকরণ করুন',
        primaryButton: 'একটি পাসকি যোগ করুন',
        title: 'পাসকি',
      },
      passwordSection: {
        primaryButton__setPassword: 'পাসওয়ার্ড সেট করুন',
        primaryButton__updatePassword: 'পাসওয়ার্ড আপডেট করুন',
        title: 'পাসওয়ার্ড',
      },
      phoneNumbersSection: {
        destructiveAction: 'ফোন নম্বর সরান',
        detailsAction__nonPrimary: 'প্রাথমিক হিসাবে সেট করুন',
        detailsAction__primary: 'যাচাইকরণ সম্পন্ন করুন',
        detailsAction__unverified: 'ফোন নম্বর যাচাই করুন',
        primaryButton: 'ফোন নম্বর যোগ করুন',
        title: 'ফোন নম্বর',
      },
      profileSection: {
        primaryButton: 'প্রোফাইল আপডেট করুন',
        title: 'প্রোফাইল',
      },
      usernameSection: {
        primaryButton__setUsername: 'ব্যবহারকারীর নাম সেট করুন',
        primaryButton__updateUsername: 'ব্যবহারকারীর নাম আপডেট করুন',
        title: 'ব্যবহারকারীর নাম',
      },
      web3WalletsSection: {
        destructiveAction: 'ওয়ালেট সরান',
        detailsAction__nonPrimary: 'প্রাথমিক হিসাবে সেট করুন',
        primaryButton: 'ওয়ালেট সংযুক্ত করুন',
        title: 'Web3 ওয়ালেট',
        web3SelectSolanaWalletScreen: {
          subtitle: 'আপনার অ্যাকাউন্টের সাথে সংযুক্ত করতে একটি Solana ওয়ালেট নির্বাচন করুন।',
          title: 'একটি Solana ওয়ালেট যোগ করুন',
        },
      },
    },
    usernamePage: {
      successMessage: 'আপনার ব্যবহারকারীর নাম আপডেট করা হয়েছে।',
      title__set: 'ব্যবহারকারীর নাম সেট করুন',
      title__update: 'ব্যবহারকারীর নাম আপডেট করুন',
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: '{{identifier}} এই অ্যাকাউন্ট থেকে সরানো হবে।',
        messageLine2: 'আপনি আর এই web3 ওয়ালেট ব্যবহার করে সাইন ইন করতে পারবেন না।',
        successMessage: '{{web3Wallet}} আপনার অ্যাকাউন্ট থেকে সরানো হয়েছে।',
        title: 'web3 ওয়ালেট সরান',
      },
      subtitle__availableWallets: 'আপনার অ্যাকাউন্টের সাথে সংযুক্ত করার জন্য একটি web3 ওয়ালেট নির্বাচন করুন।',
      subtitle__unavailableWallets: 'কোনো উপলব্ধ web3 ওয়ালেট নেই।',
      successMessage: 'ওয়ালেট আপনার অ্যাকাউন্টে যোগ করা হয়েছে।',
      title: 'web3 ওয়ালেট যোগ করুন',
      web3WalletButtonsBlockButton: '{{provider|titleize}}',
    },
  },
  waitlist: {
    start: {
      actionLink: 'সাইন ইন করুন',
      actionText: 'ইতিমধ্যে অ্যাক্সেস আছে?',
      formButton: 'ওয়েটলিস্টে যোগ দিন',
      subtitle: 'আপনার ইমেইল ঠিকানা লিখুন এবং আপনার স্থান প্রস্তুত হলে আমরা আপনাকে জানাব',
      title: 'ওয়েটলিস্টে যোগ দিন',
    },
    success: {
      message: 'আপনি শীঘ্রই রিডাইরেক্ট হবেন...',
      subtitle: 'আপনার স্থান প্রস্তুত হলে আমরা আপনার সাথে যোগাযোগ করব',
      title: 'ওয়েটলিস্টে যোগ দেওয়ার জন্য ধন্যবাদ!',
    },
  },
  web3SolanaWalletButtons: {
    connect: '{{walletName}} দিয়ে সংযুক্ত করুন',
    continue: '{{walletName}} দিয়ে চালিয়ে যান',
    noneAvailable:
      'কোনো Solana Web3 ওয়ালেট শনাক্ত হয়নি। অনুগ্রহ করে Web3 সমর্থিত {{ solanaWalletsLink || link("wallet extension") }} ইনস্টল করুন।',
  },
} as const;
